<template>
  <div>
    <div class="enterpriseInformation">
      <div class="enterpriseInformation_box">
        <div class="text">
          热门资讯
        </div>
        <div class="border_"></div>
        <div class="hot_list">
          <div class="hot_info"  @click="toCheck(item)" v-for="(item,index) in enterpriseList.slice(0,4)" :key="index">
            <div class="hot_img">
              <img :src="item.img">
            </div>
            <div class="bottom_info">
              <div class="hot_text">{{item.text}}</div>
              <div>
<!--                <div class="hot_info_info" v-html="removeImagesFromHTML(item.info)"></div>-->
                <div class="hot_time">{{item.time}}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 60px" class="text">
          更多资讯
        </div>
        <div class="border_"></div>
        <div class="enter_left">
          <div class="left_info" @click="toCheck(item)" v-for="(item,index) in enterpriseList.slice(pageNo,pageNo+4)" :key="index">
            <div class="image">
              <img :src="item.img">
            </div>
            <div class="info">

              <div class="info_text">
                {{item.text}}
              </div>

              <div class="info_title" v-html="removeImagesFromHTML(item.info)">
              </div>
              <div class="time">
                {{item.time}}
              </div>
            </div>
          </div>
        </div>
        <div class="fenye">
          <el-pagination
              layout="prev, pager, next"
              :page-size="4"
              @current-change="handleCurrentChange"
              :total="7">
          </el-pagination>
        </div>

      </div>

    </div>
    <tail_menu></tail_menu>
  </div>
</template>

<script>
import {enterpriseList} from "@/views/mock";
import tail_menu from "@/components/tail_menu_phone";

export default {
  name: "enterpriseInformation",
  components:{
    tail_menu,
  },
  data(){
    return{
      enterpriseList:enterpriseList,
      pageNo:3,
    }
  },
  methods:{
    removeImagesFromHTML(html) {
      return html.replace(/<(img|div)[^>]*>/gi, '');
    },
    toCheck(item) {
      this.$router.push({name: 'enterpriseInformationInfoPhone', query: {id: item.id}})
    },
    handleCurrentChange(val) {
      if(val == 1){
        this.pageNo = 3
      }else {
        this.pageNo = 7
      }
      console.log(`当前页: ${val}`);
    }
  }
}
</script>

<style scoped lang="scss">
.enterpriseInformation{
  display: flex;
  flex-direction: column;
  align-items: center;
  .enterpriseInformation_box{
    width: 1400px;
    padding: 50px 0;
    .text{
      font-size: 74px;
      font-weight: 600;
      color: #4a7bac;
      padding-bottom: 30px;
    }
    .border_{
      margin-top: 10px;
      width: 1400px;
      border: 2px solid #d8eaf8;
    }
    .hot_list{
      margin-top: 60px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .hot_info{
        width: 48%;
        margin-bottom: 40px;
        box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.5);

        border-radius: 8px;
        cursor: pointer;
        .hot_img{

          img{
            width: 100%;
            height: 440px;
            border-radius: 8px 8px 0 0;
          }
        }
        .bottom_info{
          padding: 20px 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 230px;
        }
        .hot_text{
          font-weight: bold;
          font-size: 47px;

        }
        .hot_info_info{
          font-size: 14px;
        }
        .hot_time{
          margin-top: 40px;
          font-size: 52px;
          text-align: right;
        }
        .hot_text,.hot_info_info{
          //width: 350px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .enter_left{
      width: 1400px;
      margin-top: 40px;
      .left_info{
        cursor: pointer;
        //border-bottom: 2px solid rgb(217,217,217);
        box-shadow: 1px 2px 6px rgba(110, 106, 106, 0.5);
        margin-bottom: 30px;
        padding: 30px 20px;
        border-radius: 8px;
        display: flex;
        .image{
          border: 1px solid rgb(217,217,217);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4px;
          img{
            width: 440px;
            height: 360px;
          }
        }
        .info{
          margin-left: 20px;
          .time{
            font-size: 42px;
            margin-top: 40px;
            color: rgb(145,146,147);
            text-align: right;
          }
          .info_text{
            font-size: 60px;
            font-weight: bold;
            margin-top: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .info_title{

            color: rgb(106,109,112);
            font-size: 44px;
            margin-top: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }

    }
    .fenye{
      display: flex;
      justify-content: center;
      margin-top: 80px;
    }
  }
}
::v-deep .el-icon{
  font-size: 50px !important;
}
::v-deep .number{
  font-size: 50px !important;
  margin-top: 10px ;
}
::v-deep ul li{
  width: 100px !important;
}
</style>
